export const Events = {
  FormSubmit: '_pbl_form_submit_',
  FormEnable: '_pbl_form_enable_',
  FormDisable: '_pbl_form_disable_',
  FormReset: '_pbl_form_reset_',
  ProcessPayment: '_pbl_process_payment_',
};

export type TEvent = typeof Events[keyof typeof Events];

// export type TEvent = string;
// export type TEventHandler<T = any> = (payload: T) => void;
// export type TEventHandler = (...events: any[]) => void;
export type TEventHandler<T = any> = (payload: T) => void;

export interface IEventBus {
  on(type: TEvent, handler: TEventHandler): void;
  off(type: TEvent, handler: TEventHandler): void;
  emit(type: TEvent, payload: any): void;
};

class EventBus implements IEventBus {
  private handlers: Record<string, TEventHandler[]> = {};

  on(type: TEvent, handler: TEventHandler) {
    (this.handlers[type] || (this.handlers[type] = [])).push(handler);
  }

  off(type: TEvent, handler?: TEventHandler) {
    if (!handler) {
      this.handlers[type] = [];
      return;
    }

    const index = this.handlers[type] && this.handlers[type].indexOf(handler);
    if (index !== -1) {
      this.handlers[type].splice(index, 1);
    }
  }

  emit(type: TEvent, payload?: any) {
    (this.handlers[type] || [])
      .forEach((handler: TEventHandler) => {
        handler(payload)
      });
  }
}

export const eventbus = new EventBus();
